import React, { FC, useEffect, useState } from "react";
import RecordPlayer, { IRecorderInstance } from "./RecordPlayer";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import MicOutlinedIcon from "@mui/icons-material/MicOutlined";
import { RECORD_RTC_RECORDER_STATES } from "../../../util/recordRtcUtils";
import AlertDialog from "../../app/alert-dialog";

interface ITranscriptRecorderProps {
    onShowRecordPlayer?: Function;
    onHideRecordPlayer?: Function;
    onUpload?: Function;
    isTeamMember?:boolean;
}

const TranscriptRecorder: FC<ITranscriptRecorderProps> = (props) => {
    const { onShowRecordPlayer, onHideRecordPlayer, onUpload } = props;
    const [showRecorder, setShowRecorder] = useState<boolean>(false);
    const [recorderState, setRecorderState] = useState<string>(null);
    const [showPendingUploadDialog, setShowPendingUploadDialog] =
        useState<boolean>(false);
    const [recorderInstance, setRecorderInstance] =
        useState<IRecorderInstance>();
    const hasPendingRecordFile =
        recorderState === RECORD_RTC_RECORDER_STATES.PAUSED ||
        recorderState === RECORD_RTC_RECORDER_STATES.STOPPED ||
        recorderState === RECORD_RTC_RECORDER_STATES.RECORDING;

    const clickblocker = (
        <Box
            className="dirty-recorder-clickblocker-effect"
            onClick={() => {
                setShowPendingUploadDialog(true);
            }}
        />
    );

    useEffect(() => {
        if (showRecorder) {
            onShowRecordPlayer();
        } else {
            onHideRecordPlayer();
        }
    }, [showRecorder]);

    return (
        <>
            {showRecorder ? (
                <>
                    <Stack
                        sx={{ width: "100%" }}
                        spacing={2}
                    >
                        <Stack
                            direction="row"
                            sx={{ alignItems: "center" }}
                        >
                            <Typography>Record Audio</Typography>
                            <IconButton
                                sx={{ marginLeft: "auto", padding: 0 }}
                                onClick={() => {
                                    setShowRecorder(false);
                                }}
                            >
                                <HighlightOffIcon />
                            </IconButton>
                        </Stack>
                        <RecordPlayer
                            className="dirty-recorder-clickblocker-effect--deactivate"
                            onUpload={onUpload}
                            onStateChange={setRecorderState}
                            onRecorderInitialization={(recorder) => {
                                setRecorderInstance(recorder);
                            }}
                        />
                    </Stack>
                    {hasPendingRecordFile && clickblocker}
                </>
            ) : (
                <Button
                    startIcon={<MicOutlinedIcon />}
                    variant="contained"
                    onClick={() => setShowRecorder(true)}
                    disabled={!props?.isTeamMember}
                >
                    Record Audio
                </Button>
            )}
            <AlertDialog
                open={showPendingUploadDialog}
                title="Want to leave?"
                description="You have a record ongoing. Do you want to discard the recording?"
                onClose={() => {
                    setShowPendingUploadDialog(false);
                }}
                confirmButton={
                    <Button
                        variant="contained"
                        onClick={() => {
                            setShowPendingUploadDialog(false);
                            recorderInstance.reset();
                        }}
                    >
                        Yes
                    </Button>
                }
                abortButton={
                    <Button
                        variant="outlined"
                        onClick={() => {
                            setShowPendingUploadDialog(false);
                        }}
                    >
                        No
                    </Button>
                }
            />
        </>
    );
};

export default TranscriptRecorder;
